<div>
    <p cvLocalizedText [langSection]="textSection" [langKey]="textTitle">Select which days will be used.</p>
    <div class="btn-group btn-group-toggle">
        <label *ngFor="let day of daysInOrder; index as i" class="btn btn-secondary btn-sm" ngbButtonLabel>
            <input type="checkbox" ngbButton [(ngModel)]="checkedDays[day]" (ngModelChange)="onDaysChanged()" [value]="day"> {{ daysLocalizedInOrder[i] }}
        </label>
    </div>
</div>